export const ENTER_KEY = 'Enter';
